import { useTranslation } from 'react-i18next';
import GoalsLimitsTable from './components/GoalsLimitsTable';
import styles from './GoalSupportProcedures.module.css';
import IconsToGoals from '@/maps/IconsToGoals';
import type { GoalDtoIn } from '@/models/in/GoalDtoIn';

const GoalSupportProcedures = ({ goal }: { goal: GoalDtoIn }) => {
  const { t } = useTranslation();
  const title = t(goal.name);
  const icon = IconsToGoals[goal.name];
  const requiredDocuments = goal.requiredDocuments ?? [];

  return (
    <>
      <div className={styles.headerBar}>
        <div className={styles.headerContent}>
          {icon && <img src={icon} alt="" className={styles.icon} />}
          <h4 className={styles.title}>{title}</h4>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.sectionHeader}>
          <h4 className={styles.sectionTitle}>{t('supportProcedures')}</h4>
          <p className={styles.sectionSubtitle}>{t('termsAndConditions')}</p>
        </div>
        <GoalsLimitsTable goalId={goal.id} />
        <div className={styles.sectionHeader}>
          <h4 className={styles.sectionTitle}>{t('goalRequiredDocuments')}</h4>
        </div>
        {requiredDocuments.length > 0 ? (
          <ul className={styles.documentsList}>
            {requiredDocuments.map((doc) => (
              <li key={doc}>{t(`GoalsRequiredDocuments.${doc}`, { defaultValue: doc })}</li>
            ))}
          </ul>
        ) : (
          <p className={styles.emptyNote}>{t('goalHasNoRequiredDocuments')}</p>
        )}
      </div>
    </>
  );
};

export default GoalSupportProcedures;


